// extracted by mini-css-extract-plugin
module.exports = {"dashStyle":"AddOnDetails_dashStyle__NGeLe"};